import React from 'react';
import {Checkbox, Text} from '@wix/wix-ui-tpa/cssVars';
import {classes} from './BillingDetails/BillingDetails.st.css';
import {useBillingData} from '../WithBillingData';
import {useLocaleKeys} from '../../../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../../../Widget/ControllerContext';
import {useMemberDetailsData} from '../../../../MemberDetails/WithMemberDetailsData';
import {ADD_NEW_ADDRESS_ID} from '../../../../constants';
import {clickOnToggleBi} from '../../../../../../types/checkoutApp.types';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../../../../common/constants';

export enum BillingSameAsShippingCheckboxDataHook {
  billingSameAsShippingToggle = 'BillingSameAsShippingCheckbox.billingSameAsShippingToggle',
  billingSameAsShippingLabel = 'BillingSameAsShippingCheckbox.billingSameAsShippingLabel',
}

export const BillingSameAsShippingCheckbox = () => {
  const {
    memberStore: {isMember},
    checkoutStore: {reportClickOnSameAsDeliveryAddressCheckbox},
  } = useControllerProps();
  const {setBillingSameAsShipping, billingSameAsShipping} = useBillingData();
  const {resetMemberDetailsState, selectedAddressesServiceId, editMode} = useMemberDetailsData();
  const localeKeys = useLocaleKeys();
  const {experiments} = useExperiments();
  const biSameAsDeliveryAddress = experiments.enabled(SPECS.BISameAsDeliveryAddress);

  const handleOnChange = ({checked}: {checked: boolean}) => {
    biSameAsDeliveryAddress &&
      reportClickOnSameAsDeliveryAddressCheckbox({action: checked ? clickOnToggleBi.CHECK : clickOnToggleBi.UNCHECK});
    setBillingSameAsShipping(checked);
    /* istanbul ignore else */
    if (isMember && (selectedAddressesServiceId === ADD_NEW_ADDRESS_ID || editMode)) {
      resetMemberDetailsState();
    }
  };
  return (
    <Checkbox
      className={classes.sameAsShippingToggle}
      data-hook={BillingSameAsShippingCheckboxDataHook.billingSameAsShippingToggle}
      label={
        <Text data-hook={BillingSameAsShippingCheckboxDataHook.billingSameAsShippingLabel}>
          {localeKeys.checkout.billing_information.billing_same_as_delivery_label()}
        </Text>
      }
      checked={billingSameAsShipping}
      onChange={handleOnChange}
    />
  );
};
